export interface Vendor {
  id: number;
  vendor: string;
  name: string;
  kind: string;
  liveupdate: boolean;
  daily_limit: number;
  threshold: number;
  cut_off_date: string | null;
  proxy: string | null;
  delay: string | null;
  published: boolean;
  tasks_to_add: number;
  note: string | null;
  /** Upper bound of the SAFE price range, in % (a price increase up to this auto-approves). */
  safe_threshold_pct: number | null;
  /** Lower bound of the SAFE range as a positive %, BOT-466 (a decrease up to this auto-approves); null = none. */
  safe_decrease_pct: number | null;
  auto_add_new_items: boolean;
  auto_approve_safe: boolean;
  /** Per-vendor half of the Home Value auto-approve gate (BOT-411). */
  auto_approve_home_value: boolean;
  /** Derived server-side: the vendor has a Home Value availability extractor. */
  home_value_lane: boolean;
  daily_logins: number;
  last_time_exported: string | null;
  is_monitored: boolean;
  headless: boolean;
}

export type VendorPatch = Partial<
  Pick<
    Vendor,
    | 'liveupdate'
    | 'daily_limit'
    | 'threshold'
    | 'cut_off_date'
    | 'proxy'
    | 'delay'
    | 'published'
    | 'tasks_to_add'
    | 'note'
    | 'safe_threshold_pct'
    | 'safe_decrease_pct'
    | 'auto_add_new_items'
    | 'auto_approve_safe'
    | 'auto_approve_home_value'
  >
>;

export async function fetchVendors(): Promise<Vendor[]> {
  const res = await fetch('/api/v1/vendors', { credentials: 'include' });
  if (!res.ok) throw new Error(`Vendors fetch failed: ${res.status}`);
  return res.json() as Promise<Vendor[]>;
}

export async function patchVendor(vendorCode: string, patch: VendorPatch): Promise<void> {
  const res = await fetch(`/api/v1/vendors/${encodeURIComponent(vendorCode)}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`Update failed: ${res.status} ${detail}`);
  }
}
